import ssoTool from "../tools/sso.tool";

export function init() {
    const formCard = $('.form-card');
    const token = new URLSearchParams(window.location.search).get('token');

    sessionStorage.setItem('token', token);
    formCard.addClass('d-none');
    ssoTool.showLoading();

    setTimeout(function(){
        ssoTool.hideLoading();
        formCard.removeClass('d-none');
    }, 10000);
}
